import { _section } from "../utils/_section";
import { _ourWorksSlider } from "../utils/_ourWorksSlider";
import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";
import { _cursorBubble } from "../utils/_cursorBubble";
import { _event } from "../utils/_event";
import gsap from "gsap";
import { _animate } from "../utils/_animate";
import { _lazyLoad } from "../utils/_lazyLoad";

class OurWorks extends MainClass {
    el: {
        header: HTMLElement | null;
        sliderNav: HTMLElement | null;
        sliderNavItems: NodeListOf<HTMLAnchorElement> | null;
    };

    instance: {
        slider: any;
        cursor: any;
    };

    constructor(props: MAIN_CLASS_PARAMS) {
        super(props);

        this.el = {
            header: this.selector.querySelector(".js-our-works-slider-header"),
            sliderNav: this.selector.querySelector(".js-our-works-slider-nav"),
            sliderNavItems: null,
        };
        this.el.sliderNavItems = this.el.sliderNav?.querySelectorAll("a") ?? null;

        this.instance = {
            slider: null,
            cursor: null,
        };

        this.init();
    }

    init() {
        // for intro animation
        new _animate();

        // for lazyload
        _lazyLoad();

        // for slider
        this.instance.slider = new _ourWorksSlider({ target: this.selector });

        // for changing cursorBubble's text
        let _currentPosition = 0;
        const _updateCursorIcon = (position) => {
            if (!this.instance.cursor) return;
            if (_currentPosition === position) return;

            if (position) {
                this.instance.cursor.el.main.classList.remove("mix-blend-overlay");
            } else {
                this.instance.cursor.el.main.classList.add("mix-blend-overlay");
            }

            this.selector.style.cursor = position === null || position === "hide" ? "" : "none";

            this.instance.cursor.el.text.innerHTML = position === "left" ? "Prev" : position === "right" ? "Next" : "";

            gsap.to(this.instance.cursor.el.bg, {
                duration: 0.3,
                width: !position ? 12 : 104,
                height: !position ? 12 : 104,
                scale: position === "hide" ? 0 : 1,
            });

            gsap.fromTo(
                this.instance.cursor.el.text,
                { opacity: 0, left: position === "left" ? 16 : -16 },
                { duration: 0.3, opacity: 1, left: 0 },
            );

            _currentPosition = position;
        };

        // to update slide
        const _updateSlide = (position: string) => {
            const _slides = this.instance.slider.el.slides.length;
            let _slideTo =
                position === "left"
                    ? this.instance.slider.currentSlide - 1
                    : position === "right"
                    ? this.instance.slider.currentSlide + 1
                    : null;

            if (_slideTo < 0) _slideTo = _slides - 1;
            if (_slideTo >= _slides) _slideTo = 0;

            this.instance.slider.update(_slideTo);
        };

        // for nav
        _event.resize(() => {
            this.el.sliderNav.style.top = `${
                this.el.header
                    ? this.el.header.offsetHeight - parseFloat(getComputedStyle(this.el.header).paddingTop)
                    : 0
            }px`;
        });

        const _updateNav = () => {
            this.el.sliderNavItems.forEach((item, index) => {
                if (index === this.instance.slider.currentSlide) {
                    item.classList.add("active");
                } else {
                    item.classList.remove("active");
                }
            });
        };

        this.el.sliderNavItems.forEach((item, index) => {
            const _item = item;

            _item.addEventListener("click", (e) => {
                e.preventDefault();

                this.instance.slider.update(index);
            });
        });
        this.instance.slider.on("update", _updateNav);
        _updateNav();

        if (!_section.isMobile())
            this.instance.cursor = new _cursorBubble({
                target: this.selector,
                events: {
                    init: (instance, event) => {},
                    mouseenter: (instance, event) => {
                        // show the cursorBubble
                        _updateCursorIcon("show");
                    },
                    mouseleave: (instance, event) => {
                        // hide the cursorBubble
                        _updateCursorIcon("hide");
                    },
                    mousemove: (instance, event) => {
                        // change cursorBubble's text
                        let _position = event.target.closest("a")
                            ? null
                            : event.clientX <= window.innerWidth * 0.5
                            ? "left"
                            : "right";

                        if (this.el.sliderNav.contains(event.target)) _position = "hide";

                        _updateCursorIcon(_position);
                    },
                    mousedown: (instance, event) => {
                        // when clicked
                        if (_currentPosition && _currentPosition !== "hide") _updateSlide(_currentPosition);
                    },
                },
            });

        // console.log("OurWorks", this);
    }
}

export default OurWorks;
